import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DesignAngularKitModule } from 'design-angular-kit';

@Component({
  selector: 'app-complete-request-modal',
  standalone: true,
  imports: [CommonModule, DesignAngularKitModule, FormsModule],
  templateUrl: './complete-request-modal.component.html',
  styleUrl: './complete-request-modal.component.scss',
})
export class CompleteRequestModalComponent {
  @Output() cancelled = new EventEmitter<void>();
  @Output() requestConfirmed = new EventEmitter<{ dischargeDate: Date | null, dischargeTime: string | null, note: string | null }>();

  dischargeDate: Date | null = null;
  dischargeTime: string | null = null;
  note: string = '';

  cancel(): void {
    this.cancelled.emit();
  }
  confirm() {
    this.requestConfirmed.emit({dischargeDate: this.dischargeDate, dischargeTime: this.dischargeTime, note: this.note});
  }
}
